import { render } from "./AwardsConfig.vue?vue&type=template&id=2d72c04c"
import script from "./AwardsConfig.vue?vue&type=script&lang=js"
export * from "./AwardsConfig.vue?vue&type=script&lang=js"

import "./AwardsConfig.vue?vue&type=style&index=0&id=2d72c04c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__